import { Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { ParseMaterial, idsFromRanges } from "../../util/Materialperser";
import { useInputStateType } from "../../util/useInput";
import { VoidAction } from "../../util/func";

export type OpenQrScannerInitialData = {
  QRIDs: number[]
};

export type QRScannerInputProps<T extends Record<K, number[] | null>, K extends keyof T> = {
  state: useInputStateType<T, K>;
  onFinished: (value: T[K]) => void;
  onCancel: VoidAction;
};

export function QRCodeInput<T extends Record<K, number[] | null>, K extends keyof T>({ state, onFinished, onCancel }: QRScannerInputProps<T, K>) {
  // ParseMaterial の結果(number[])をジェネリックな入力スロット型 T[K] へ写す境界。
  // T[K] は number[] | null 制約のため実体は常に互換だが、TS は型パラメータの実体を検証できない。
  const asSlotValue = (ids: number[]): T[K] => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ジェネリック入力スロットへの橋渡し(制約により実体は互換)
    return ids as T[K];
  };
  useEffect(() => {
    if (window.webkit) {
      const postCommand: OpenQrScannerInitialData = { QRIDs: state.value ?? [] };
      console.log(postCommand);
      window.webkit.messageHandlers.openQRScanner.postMessage(postCommand);
    }
    const handle = (event: Event) => {
      if (!(event instanceof CustomEvent)) {
        return;
      }
      queueMicrotask(() => {
        console.log(event.detail)
        const detail: unknown = event.detail;
        const detailText = typeof detail === "string" ? detail : "";
        if (detailText !== "") {
          console.log("更新します。");
          // スキャン結果は実在QRの列挙で件数が限られるため、範囲を id 列へ展開して扱う
          const parsedIds = asSlotValue(idsFromRanges(ParseMaterial(detailText)));
          state.setValue(parsedIds);
          onFinished(parsedIds);
        } else {
          console.log("キャンセルします。");
          onCancel();
        }
      });
    }

    window.addEventListener("qrCodeDataJson", handle);
    return () => {
      window.removeEventListener("qrCodeDataJson", handle);
    }
  }, []);

  if (!window.webkit) {
    return(
      <Stack pt={4}>
        <Typography>webkitが見つからないため、QRスキャンを開始できません。</Typography>
        <Typography>QRコードスキャンはアプリ限定の機能です。</Typography>
      </Stack>
    );
  }

  return <>QRスキャナを待機しています。</>;
}